export const get_top_nav_settings = (state) => state.topNavigation;
export const get_side_nav_settings = (state) => state.sideNavigation;
export const get_languages = (state) => state.languages;
export const get_alert = (state) => state.alert;
